module.exports = __webpack_public_path__ + "images/ebd8a727c70474078008405ee4b80d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/diaryofanant-locations01.jpg
// module id = ./webpack/assets/img/diaryofanant-locations01.jpg
// module chunks = 0